import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import Header from '../components/Header';

const C = {
  trasporto: '#EB1C24', alloggio: '#0071BA', attivita: '#FF5B00', servizi: '#009045',
  dark: '#0a1628', darker: '#060e1c', white: '#ffffff',
  text: '#1a1a2e', textLight: '#6b7280', border: '#e5e7eb', light: '#f5f7fa',
};

const LINGUE = ['Italiano', 'English', 'Español', 'Français', 'Deutsch'];
const VALUTE = ['EUR — Euro', 'USD — Dollaro USA', 'GBP — Sterlina', 'CHF — Franco svizzero'];
const AREE_GEOGRAFICHE = ['Europa', 'Nord America', 'Centro e Sud America', 'Asia', 'Africa', 'Oceania'];
const METODI_PAGAMENTO = [
  { id: 'carta', label: 'Carta di credito/debito' },
  { id: 'paypal', label: 'PayPal' },
  { id: 'bonifico', label: 'Bonifico bancario' },
];

function Field({ label, children }) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      <span style={{ fontSize: '12px', fontWeight: 600, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{label}</span>
      {children}
    </label>
  );
}

const inputStyle = {
  padding: '10px 14px', borderRadius: '8px', border: `1px solid ${C.border}`,
  fontSize: '14px', fontFamily: 'inherit', width: '100%', boxSizing: 'border-box', color: C.text,
};

function Sezione({ titolo, sottotitolo, children }) {
  return (
    <div style={{ backgroundColor: C.white, borderRadius: '16px', border: `1px solid ${C.border}`, padding: '28px', display: 'flex', flexDirection: 'column', gap: '18px' }}>
      <div>
        <h2 style={{ fontSize: '18px', fontWeight: 900 }}>{titolo}</h2>
        {sottotitolo && <p style={{ fontSize: '13px', color: C.textLight, marginTop: '4px' }}>{sottotitolo}</p>}
      </div>
      {children}
    </div>
  );
}

function Bottone({ onClick, disabled, children }) {
  return (
    <button onClick={onClick} disabled={disabled} style={{
      alignSelf: 'flex-start', padding: '10px 22px', borderRadius: '8px', border: 'none',
      backgroundColor: C.alloggio, color: C.white, fontSize: '13px', fontWeight: 700,
      opacity: disabled ? 0.5 : 1, cursor: disabled ? 'default' : 'pointer',
    }}>
      {children}
    </button>
  );
}

export default function Impostazioni() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const [generale, setGenerale] = useState({
    username: '', lingua: LINGUE[0], valuta: VALUTE[0], area_geografica: AREE_GEOGRAFICHE[0],
    indirizzo_via: '', indirizzo_cap: '', indirizzo_citta: '', indirizzo_regione: '',
  });
  const [avatarUrl, setAvatarUrl] = useState('');
  const [uploadingAvatar, setUploadingAvatar] = useState(false);
  const [savingGenerale, setSavingGenerale] = useState(false);
  const [msgGenerale, setMsgGenerale] = useState('');

  const [personale, setPersonale] = useState({
    nome: '', cognome: '', data_nascita: '', telefono: '', numero_passaporto: '', numero_carta_identita: '',
  });
  const [savingPersonale, setSavingPersonale] = useState(false);
  const [msgPersonale, setMsgPersonale] = useState('');

  const [email, setEmail] = useState('');
  const [savingEmail, setSavingEmail] = useState(false);
  const [msgEmail, setMsgEmail] = useState('');

  const [nuovaPassword, setNuovaPassword] = useState('');
  const [confermaPassword, setConfermaPassword] = useState('');
  const [savingPassword, setSavingPassword] = useState(false);
  const [msgPassword, setMsgPassword] = useState('');

  const [metodoPagamento, setMetodoPagamento] = useState('');
  const [savingPagamento, setSavingPagamento] = useState(false);
  const [msgPagamento, setMsgPagamento] = useState('');

  useEffect(() => {
    const init = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) { navigate('/login'); return; }
      setUser(session.user);
      setEmail(session.user.email || '');

      const { data: prof } = await supabase.from('profiles').select('*').eq('id', session.user.id).single();
      if (prof) {
        setGenerale({
          username: prof.username || '',
          lingua: prof.lingua || LINGUE[0],
          valuta: prof.valuta || VALUTE[0],
          area_geografica: prof.area_geografica || AREE_GEOGRAFICHE[0],
          indirizzo_via: prof.indirizzo_via || '',
          indirizzo_cap: prof.indirizzo_cap || '',
          indirizzo_citta: prof.indirizzo_citta || '',
          indirizzo_regione: prof.indirizzo_regione || '',
        });
        setAvatarUrl(prof.avatar_url || '');
        setPersonale({
          nome: prof.nome || '',
          cognome: prof.cognome || '',
          data_nascita: prof.data_nascita || '',
          telefono: prof.telefono || '',
          numero_passaporto: prof.numero_passaporto || '',
          numero_carta_identita: prof.numero_carta_identita || '',
        });
        setMetodoPagamento(prof.metodo_pagamento_preferito || '');
      }
      setLoading(false);
    };
    init();
  }, [navigate]);

  const handleAvatarChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !user) return;
    setUploadingAvatar(true);
    const estensione = file.name.split('.').pop();
    const percorso = `${user.id}/avatar.${estensione}`;
    const { error: erroreUpload } = await supabase.storage.from('avatars').upload(percorso, file, { upsert: true });
    if (erroreUpload) {
      setMsgGenerale('Caricamento foto non riuscito. Verifica che il bucket "avatars" esista su Supabase.');
      setUploadingAvatar(false);
      return;
    }
    const { data } = supabase.storage.from('avatars').getPublicUrl(percorso);
    const nuovoUrl = `${data.publicUrl}?t=${Date.now()}`;
    await supabase.from('profiles').update({ avatar_url: nuovoUrl }).eq('id', user.id);
    setAvatarUrl(nuovoUrl);
    setUploadingAvatar(false);
  };

  const salvaGenerale = async () => {
    setSavingGenerale(true); setMsgGenerale('');
    const { error } = await supabase.from('profiles').update(generale).eq('id', user.id);
    setMsgGenerale(error ? 'Salvataggio non riuscito.' : 'Salvato.');
    setSavingGenerale(false);
  };

  const salvaPersonale = async () => {
    setSavingPersonale(true); setMsgPersonale('');
    const { error } = await supabase.from('profiles').update(personale).eq('id', user.id);
    setMsgPersonale(error ? 'Salvataggio non riuscito.' : 'Salvato.');
    setSavingPersonale(false);
  };

  const salvaEmail = async () => {
    setSavingEmail(true); setMsgEmail('');
    const { error } = await supabase.auth.updateUser({ email });
    setMsgEmail(error ? 'Aggiornamento non riuscito.' : 'Controlla la tua email per confermare il cambio.');
    setSavingEmail(false);
  };

  const salvaPassword = async () => {
    setMsgPassword('');
    if (nuovaPassword.length < 6) { setMsgPassword('Minimo 6 caratteri.'); return; }
    if (nuovaPassword !== confermaPassword) { setMsgPassword('Le password non coincidono.'); return; }
    setSavingPassword(true);
    const { error } = await supabase.auth.updateUser({ password: nuovaPassword });
    setMsgPassword(error ? 'Aggiornamento non riuscito.' : 'Password aggiornata.');
    if (!error) { setNuovaPassword(''); setConfermaPassword(''); }
    setSavingPassword(false);
  };

  const salvaPagamento = async () => {
    setSavingPagamento(true); setMsgPagamento('');
    const { error } = await supabase.from('profiles').update({ metodo_pagamento_preferito: metodoPagamento }).eq('id', user.id);
    setMsgPagamento(error ? 'Salvataggio non riuscito.' : 'Preferenza salvata.');
    setSavingPagamento(false);
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: C.light }}>
      <p style={{ color: C.textLight, fontFamily: 'Roboto, sans-serif' }}>Caricamento...</p>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', backgroundColor: C.light, fontFamily: 'Roboto, sans-serif', color: C.text }}>
      <style>{`
        @font-face{font-family:'Roboto';src:url('/fonts/Roboto-Regular.ttf');font-weight:400}
        @font-face{font-family:'Roboto';src:url('/fonts/Roboto-Bold.ttf');font-weight:700}
        @font-face{font-family:'Roboto';src:url('/fonts/Roboto-Black.ttf');font-weight:900}
        *{box-sizing:border-box}
        a{text-decoration:none} button{cursor:pointer} button:hover{opacity:0.9}
        input:focus,select:focus{outline:none;border-color:${C.alloggio}!important}
        @media(max-width:640px){
          .octa-header-imp{padding:12px 16px!important}
          .octa-main-imp{padding:24px 16px!important}
          .octa-griglia2{grid-template-columns:1fr!important}
        }
      `}</style>

      <Header bg={C.dark} />

      <main className="octa-main-imp" style={{ padding: '40px 20px', maxWidth: '760px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <h1 style={{ fontSize: '26px', fontWeight: 900 }}>Impostazioni</h1>

        {/* ── GENERALE ── */}
        <Sezione titolo="Generale" sottotitolo="Nome utente, foto, lingua, valuta e indirizzo di residenza.">
          <div style={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
            <div style={{
              width: '64px', height: '64px', borderRadius: '50%', flexShrink: 0, overflow: 'hidden',
              backgroundColor: C.alloggio, display: 'flex', alignItems: 'center', justifyContent: 'center',
              backgroundImage: avatarUrl ? `url(${avatarUrl})` : 'none', backgroundSize: 'cover', backgroundPosition: 'center',
            }}>
              {!avatarUrl && <span style={{ fontSize: '22px', fontWeight: 900, color: C.white }}>{(generale.username || 'U').slice(0, 2).toUpperCase()}</span>}
            </div>
            <label style={{ fontSize: '13px', color: C.alloggio, fontWeight: 700 }}>
              {uploadingAvatar ? 'Caricamento...' : 'Cambia foto profilo'}
              <input type="file" accept="image/*" onChange={handleAvatarChange} disabled={uploadingAvatar} style={{ display: 'none' }} />
            </label>
          </div>

          <Field label="Nome utente">
            <input style={inputStyle} value={generale.username} onChange={(e) => setGenerale({ ...generale, username: e.target.value })} />
          </Field>

          <div className="octa-griglia2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <Field label="Lingua">
              <select style={inputStyle} value={generale.lingua} onChange={(e) => setGenerale({ ...generale, lingua: e.target.value })}>
                {LINGUE.map((l) => <option key={l} value={l}>{l}</option>)}
              </select>
            </Field>
            <Field label="Valuta">
              <select style={inputStyle} value={generale.valuta} onChange={(e) => setGenerale({ ...generale, valuta: e.target.value })}>
                {VALUTE.map((v) => <option key={v} value={v}>{v}</option>)}
              </select>
            </Field>
          </div>

          <Field label="Area geografica di appartenenza">
            <select style={inputStyle} value={generale.area_geografica} onChange={(e) => setGenerale({ ...generale, area_geografica: e.target.value })}>
              {AREE_GEOGRAFICHE.map((a) => <option key={a} value={a}>{a}</option>)}
            </select>
          </Field>

          <p style={{ fontSize: '12px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.05em', marginTop: '4px' }}>Indirizzo di residenza</p>
          <div className="octa-griglia2" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
            <Field label="Via">
              <input style={inputStyle} value={generale.indirizzo_via} onChange={(e) => setGenerale({ ...generale, indirizzo_via: e.target.value })} placeholder="Via Roma 12" />
            </Field>
            <Field label="CAP">
              <input style={inputStyle} value={generale.indirizzo_cap} onChange={(e) => setGenerale({ ...generale, indirizzo_cap: e.target.value })} placeholder="20100" />
            </Field>
          </div>
          <div className="octa-griglia2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <Field label="Città">
              <input style={inputStyle} value={generale.indirizzo_citta} onChange={(e) => setGenerale({ ...generale, indirizzo_citta: e.target.value })} placeholder="Milano" />
            </Field>
            <Field label="Regione">
              <input style={inputStyle} value={generale.indirizzo_regione} onChange={(e) => setGenerale({ ...generale, indirizzo_regione: e.target.value })} placeholder="Lombardia" />
            </Field>
          </div>

          <Bottone onClick={salvaGenerale} disabled={savingGenerale}>{savingGenerale ? 'Salvataggio...' : 'Salva sezione generale'}</Bottone>
          {msgGenerale && <p style={{ fontSize: '13px', color: C.textLight }}>{msgGenerale}</p>}
        </Sezione>

        {/* ── INFORMAZIONI PERSONALI ── */}
        <Sezione titolo="Informazioni personali" sottotitolo="Dati anagrafici, contatti e documenti.">
          <div className="octa-griglia2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <Field label="Nome">
              <input style={inputStyle} value={personale.nome} onChange={(e) => setPersonale({ ...personale, nome: e.target.value })} />
            </Field>
            <Field label="Cognome">
              <input style={inputStyle} value={personale.cognome} onChange={(e) => setPersonale({ ...personale, cognome: e.target.value })} />
            </Field>
          </div>
          <div className="octa-griglia2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <Field label="Data di nascita">
              <input type="date" style={inputStyle} value={personale.data_nascita} onChange={(e) => setPersonale({ ...personale, data_nascita: e.target.value })} />
            </Field>
            <Field label="Telefono">
              <input type="tel" style={inputStyle} value={personale.telefono} onChange={(e) => setPersonale({ ...personale, telefono: e.target.value })} placeholder="+39 333 1234567" />
            </Field>
          </div>
          <div className="octa-griglia2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <Field label="Numero passaporto">
              <input style={inputStyle} value={personale.numero_passaporto} onChange={(e) => setPersonale({ ...personale, numero_passaporto: e.target.value })} />
            </Field>
            <Field label="Numero carta d'identità">
              <input style={inputStyle} value={personale.numero_carta_identita} onChange={(e) => setPersonale({ ...personale, numero_carta_identita: e.target.value })} />
            </Field>
          </div>
          <Bottone onClick={salvaPersonale} disabled={savingPersonale}>{savingPersonale ? 'Salvataggio...' : 'Salva informazioni personali'}</Bottone>
          {msgPersonale && <p style={{ fontSize: '13px', color: C.textLight }}>{msgPersonale}</p>}

          <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: '18px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Field label="Email">
              <input type="email" style={inputStyle} value={email} onChange={(e) => setEmail(e.target.value)} />
            </Field>
            <Bottone onClick={salvaEmail} disabled={savingEmail}>{savingEmail ? 'Invio...' : 'Aggiorna email'}</Bottone>
            {msgEmail && <p style={{ fontSize: '13px', color: C.textLight }}>{msgEmail}</p>}
          </div>

          <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: '18px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div className="octa-griglia2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <Field label="Nuova password">
                <input type="password" style={inputStyle} value={nuovaPassword} onChange={(e) => setNuovaPassword(e.target.value)} />
              </Field>
              <Field label="Conferma password">
                <input type="password" style={inputStyle} value={confermaPassword} onChange={(e) => setConfermaPassword(e.target.value)} />
              </Field>
            </div>
            <Bottone onClick={salvaPassword} disabled={savingPassword}>{savingPassword ? 'Aggiornamento...' : 'Cambia password'}</Bottone>
            {msgPassword && <p style={{ fontSize: '13px', color: C.textLight }}>{msgPassword}</p>}
          </div>
        </Sezione>

        {/* ── METODI DI PAGAMENTO ── */}
        <Sezione titolo="Metodi di pagamento" sottotitolo="Solo la preferenza: nessun dato di pagamento reale viene raccolto qui, in attesa di scegliere e collegare un fornitore.">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {METODI_PAGAMENTO.map((m) => (
              <label key={m.id} style={{
                display: 'flex', alignItems: 'center', gap: '10px', padding: '12px 16px',
                borderRadius: '8px', border: `1px solid ${metodoPagamento === m.id ? C.alloggio : C.border}`,
                backgroundColor: metodoPagamento === m.id ? 'rgba(0,113,186,0.06)' : 'transparent', fontSize: '14px',
              }}>
                <input type="radio" name="metodoPagamento" checked={metodoPagamento === m.id} onChange={() => setMetodoPagamento(m.id)} />
                {m.label}
              </label>
            ))}
          </div>
          <p style={{ fontSize: '12px', color: C.textLight }}>
            Nessun metodo di pagamento reale è ancora attivo: questa sezione salva solo la preferenza per quando l'integrazione sarà pronta.
          </p>
          <Bottone onClick={salvaPagamento} disabled={savingPagamento || !metodoPagamento}>{savingPagamento ? 'Salvataggio...' : 'Salva preferenza'}</Bottone>
          {msgPagamento && <p style={{ fontSize: '13px', color: C.textLight }}>{msgPagamento}</p>}
        </Sezione>
      </main>

      {/* FOOTER */}
      <footer style={{ padding: '32px 40px', borderTop: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
        <img src="/images/logo.png" alt="OCTA" style={{ height: '28px', objectFit: 'contain' }} />
        <p style={{ fontSize: '13px', color: C.textLight }}>© 2026 OCTA — Online Complete Travel Agency</p>
      </footer>
    </div>
  );
}
